/**
 * Domain enums — see §6.1. Values here are the API/UI contract; the mapping to the
 * exact legacy DB magic-numbers (e.g. First/Last position integers) lives in the
 * backend's persistence layer, NOT here, because the add/edit forms used different
 * legacy magic numbers (§6.1 note) — only the relative order (First < Last) matters.
 */
/** Advertisement position — a binary radio in legacy (First / Last). */
export const AdPosition = {
    First: "first",
    Last: "last",
};
/** advertisement_status — Active=1 / Inactive=0. */
export const AdStatus = {
    Inactive: 0,
    Active: 1,
};
/** linkType → advertisement_attachment_type. */
export const LinkType = {
    WebUrl: "weburl",
    Email: "email",
};
/**
 * frmAdsType — product-type scope. Drives the placement rows written into
 * austn_advertisement_to_product_type_position (§6.1):
 *   newsletter → 1 row (type 1); all → 3 rows (newsletter=1, event=5, survey=4);
 *   event → row type 5; survey → row type 4.
 */
export const AdsType = {
    Newsletter: "newsletter",
    Event: "event",
    Survey: "survey",
    All: "all",
};
/** Legacy austn_advertisement_to_product_type_position.fk_product_type_id values. */
export const ProductTypeId = {
    Newsletter: 1,
    Survey: 4,
    Event: 5,
};
/** Map an AdsType to the product-type ids it expands to (§6.1). */
export function productTypeIdsFor(adsType) {
    switch (adsType) {
        case AdsType.Newsletter:
            return [ProductTypeId.Newsletter];
        case AdsType.Event:
            return [ProductTypeId.Event];
        case AdsType.Survey:
            return [ProductTypeId.Survey];
        case AdsType.All:
            return [ProductTypeId.Newsletter, ProductTypeId.Event, ProductTypeId.Survey];
    }
}
//# sourceMappingURL=enums.js.map